import React from 'react';
import {useSelector} from "react-redux";
import {selectCurrentToken} from "../../../../../features/authentication/authenticationSelectors";
import {DataManager, WebApiAdaptor} from "@syncfusion/ej2-data";
import DropdownRemoteGridFilter from "../../../../ui/components/Grid/filters/DropdownRemoteGridFilter";

const ServiceWorkCategoryFilter = ({onFilterChange, ...rest}) => {
    const token = useSelector(selectCurrentToken);

    const data = new DataManager({
        adaptor: new WebApiAdaptor(),
        url: `${process.env.REACT_APP_BE_DOMAIN}/api/service360/getService360List?all=1`,
        headers: [
            {
                'Authorization': `bearer ${token}`
            }
        ]
    });

    return <DropdownRemoteGridFilter onChange={onFilterChange} {...rest} dataSource={data}/>;
};

export default ServiceWorkCategoryFilter;

